import React from "react";
import NumerableList from "../components/NumerableList";
import ComponentContainer from "../components/ComponentContainer";

const PublicOffer = () => {
  return (
    <div className="public-offer-page">
      <ComponentContainer>
        <h1 className="mb-2">ДОГОВОР ОФЕРТЫ</h1>
        <NumerableList>
          <ol className="nested-list">
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ПРЕДМЕТ И ОБЩИЕ ПОЛОЖЕНИЯ
              </div>

              <ol>
                <li>
                  Настоящее соглашение представляет собой официальное
                  предложение (оферту) на пользование услугами сервиса{" "}
                  <b>«MEGALODON»</b>, доступного через канал <b>Discord</b>,
                  адресованное физическим лицам, принявшим (акцептовавшим)
                  настоящую оферту на изложенных ниже условиях.
                </li>
                <li>
                  В соответствии с п. 2 ст. 437 ГК РФ данный документ является
                  публичной офертой. В случае принятия изложенных ниже условий,
                  лицо, осуществившее акцепт настоящей оферты (пользователь),
                  становится Участником проекта. В соответствии с п. 3 ст. 438
                  ГК РФ акцепт оферты равносилен заключению договора на
                  условиях, изложенных в оферте.
                </li>
                <li>
                  Указанное в настоящем Соглашении безоговорочно принимается
                  Участником.
                </li>
                <li>
                  Услугами Сервиса могут пользоваться исключительно лица,
                  достигшие 16 лет.
                </li>
                <li>
                  Сервис представляет собой систему купли-продажи услуг, которые
                  предоставляет <b>Discord-канал</b> сервиса <b>«MEGALODON»</b>.
                </li>
                <li>
                  Каждый Участник получает доступ к системе покупок после
                  авторизации.
                </li>
                <li>
                  Отношения между Сервисом и Участником считаются надлежаще
                  оформленными с момента акцепта оферты и не требуют
                  двустороннего подписания в письменном виде.
                </li>
                <li>
                  Акцептом настоящей оферты для Участника признается начало
                  использования Сервиса, его отдельной функции, либо прохождение
                  процедуры регистрации через бота в <b>Discord</b>.
                </li>
                <li>
                  Независимо от факта регистрации или авторизации Пользователя в
                  <b>Discord</b>, использование Сервиса, включая выполнение
                  команд бота и просмотр размещенной на платформе информации,
                  означает согласие Участника с настоящим соглашением.
                </li>
                <li>
                  Используя и/или взаимодействуя с ботом в <b>Discord</b>,
                  Участник:{" "}
                  <ul>
                    <li>
                      соглашается использовать средства электронной коммуникации
                      для заключения договоров;
                    </li>
                    <li>
                      отказывается от любых применимых в данном случае прав или
                      требований, для которых необходима собственноручная
                      подпись, в той степени, в которой это допускается любым
                      применимым законодательным актом.
                    </li>
                  </ul>
                </li>
                <li>
                  Если Участник не согласен принять и следовать условиям
                  Соглашения, он не должен регистрировать аккаунт и/или
                  прекратить использовать аккаунт. Дальнейшее использование
                  Сервиса будет рассматриваться как согласие Участника с
                  условиями настоящего Соглашения.
                </li>
                <li>
                  Участник осознает и согласен с тем, что он должен
                  самостоятельно оценивать все риски, связанные с использованием
                  Сервиса, включая оценку его надежности, полноты или
                  полезности.
                </li>
                <li>
                  Администрация Сервиса осуществляет техническую поддержку
                  Участника по вопросам, связанным с функциональностью бота и с
                  особенностями эксплуатации Сервиса в <b>Discord</b>.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                УЧЁТНАЯ ЗАПИСЬ УЧАСТНИКА
              </div>
              <ol>
                <li>
                  Способом непосредственной регистрации учетной записи является
                  авторизация Участника через бота <b>Discord</b> с помощью
                  данных социальной сети «Steam».
                </li>
                <li>
                  Участник принимает на себя обязательство хранения
                  конфиденциальности информации, размещенной в его учетной
                  записи, и доступа к своей учетной записи.
                </li>
                <li>
                  В случае нарушения Участником условий настоящего соглашения
                  или действующих законов РФ, Сервис вправе в любое время
                  заблокировать или удалить учетную запись Участника без
                  возможности её восстановления и без объяснения причин.
                </li>
                <li>
                  Участник обязуется своевременно сообщить о несанкционированном
                  доступе к его учетной записи или нарушении условий соглашения,
                  а также о любых подозрительных действиях, связанных с его
                  учетной записью, в службу технической поддержки Сервиса.
                </li>
                <li>
                  Сервис не несет ответственности за разглашение учетной записи
                  Участника третьим лицам и за последствия несанкционированного
                  доступа третьих лиц.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ПРАВИЛА ПОЛЬЗОВАНИЯ СЕРВИСОМ
              </div>
              <ol>
                <li>
                  Пополнение баланса в Сервисе осуществляется Участником
                  добровольно.
                </li>
                <li>
                  Сумма пополнения баланса определяется Участником, исходя из
                  его целей использования Сервиса.
                </li>
                <li>
                  Участник приобретает подписку, купон или цифровую модель через
                  <b>бота в Discord</b>.
                </li>
                <li>
                  Покупки, совершенные Участником, направляются на
                  усовершенствование Сервиса и расширение услуг, необходимых для
                  стабильной работы Сервиса.
                </li>
                <li>
                  Сервис также предоставляет услуги и продает цифровые товары.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                КОНФИДЕНЦИАЛЬНОСТЬ
              </div>
              <ol>
                <li>
                  Сервис гарантирует абсолютную конфиденциальность информации,
                  предоставленной Участником Сервису.
                </li>
                <li>
                  Личные данные Участника могут быть предоставлены третьим лицам
                  только в случаях, прямо предусмотренных действующими законами
                  РФ (например, в случае оскорбительного поведения, клеветы, или
                  иных нарушений законов).
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                КАТЕГОРИЧЕСКИ ЗАПРЕЩЕНО
              </div>
              <ol>
                <li>
                  Передача любой информации или материалов, способных причинить
                  ущерб третьим лицам или нарушить действующие законы РФ в
                  отношении третьих лиц.
                </li>
                <li>Наносить ущерб работе системы Сервиса.</li>
                <li>
                  Размещение информации, способной причинить ущерб третьим
                  лицам.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ОТВЕТСТВЕННОСТЬ СТОРОН
              </div>
              <ol>
                <li>
                  Приобретая подписку через <b>бота в Discord</b> и тратя
                  средства со своего баланса, Участник берет на себя полную
                  ответственность за свои действия.
                </li>
                <li>
                  Сервис несет ответственность за хранение и обработку
                  персональных данных Участника и обеспечивает
                  конфиденциальность этих данных в процессе их обработки. Сервис
                  не несет ответственности за утрату персональных данных
                  Участника в результате хакерских атак.
                </li>
                <li>
                  Сервис не несет ответственности за неработоспособность бота
                  или канала в связи с проблемами с сервером, сбоями системы или
                  другими обстоятельствами, не зависящими от Сервиса.
                </li>
                <div className="own-numerability three-digits">
                  <li data-marker="6.1.0.">
                    <b>Политика возврата</b>
                  </li>
                  <li data-marker="6.1.1.">
                    Сервис не предоставляет возврат средств в рублях или в
                    другой реальной валюте, за исключением форс-мажорных
                    ситуаций. Любые компенсации и возвраты начисляются
                    Участникам на личный баланс в валюте проекта <b>Зубы</b>,
                    исключительно в случае индивидуального разбора ситуации
                    администрацией Сервиса.
                  </li>
                  <li data-marker="6.1.2.">
                    В случае технических ошибок, системных сбоев или
                    форс-мажорных обстоятельств, Сервис обязуется провести
                    возврат средств Пользователю в валюте Сервиса (Зубы) или
                    рублях по выбору Пользователя. Возврат осуществляется только
                    в размере той суммы, которая не дошла до Сервиса или была
                    утрачена.
                  </li>
                  <li data-marker="6.1.3.">
                    В случае форс-мажорных обстоятельств Участник должен
                    обратиться к администрации Сервиса (через дискорд или по
                    электронной почте, указанные ниже) и запросить возврат,
                    предоставив сведения о форс-мажорной ситуации. Денежные
                    средства будут возвращены в течение 24 часов на реквизиты, с
                    которых было произведено пополнение.
                  </li>
                </div>
              </ol>
            </li>

            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ПОЛИТИКА ИНФОРМАЦИОННОЙ БЕЗОПАСНОСТИ
              </div>
              <ol>
                <li>
                  Оплатить заказ можно через несколько платежных систем,
                  включая, но не ограничиваясь,{" "}
                  <b>Робокассой, банковскими картами Visa, MasterCard, Мир</b>{" "}
                  или через другие доступные платежные платформы. Для оплаты вы
                  будете перенаправлены на сервер соответствующей платежной
                  системы, где необходимо ввести необходимые данные. Системы
                  оплаты, такие как <b>Робокасса</b>, соответствуют
                  международным стандартам безопасности, включая PCI DSS, и
                  гарантируют безопасность обработки данных. Платежная система
                  также обеспечивает защиту ваших конфиденциальных данных.
                </li>
              </ol>
            </li>
            <li>
              <div className="head gradient-text font-size-1-75 semi-bold">
                ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ
              </div>
              <ol>
                <li>
                  Соглашение вступает в силу с даты акцепта и действует до тех
                  пор, пока Участник или Сервис не расторгнут его. Расторжение
                  соглашения возможно в любое время. В случае расторжения
                  Участник обязан немедленно прекратить использование Сервиса.
                </li>
                <li>
                  Право пользования Сервисом прекращается и Соглашение
                  расторгается автоматически, без уведомления Участника, если
                  Участник нарушает условия настоящего Соглашения.
                </li>
                <li>
                  В случае отзыва Соглашения в течение срока его действия,
                  Соглашение считается прекращенным с момента отзыва. Отзыв
                  осуществляется путем размещения соответствующей информации на{" "}
                  <b>Discord-канале</b>.
                </li>
              </ol>
            </li>
          </ol>
        </NumerableList>
        <div className="contacts">
          <p>
            <b>Контакты:</b>
          </p>
          <p>
            Почта:{" "}
            <a href="mailto:megalodontheisle@gmail.com">
              megalodontheisle@gmail.com
            </a>
          </p>
          <p>ИП: Ордуханов Исмат Али Оглы</p>
          <p>ИНН: 781700435305</p>
        </div>
      </ComponentContainer>
    </div>
  );
};

export default PublicOffer;
